const session = (function () {
    const SESSION_KEY_LOGIN_INFO = "thinq-login-info";
    const SESSION_KEY_THEME = "theme";

    function set_loginInfo(data) {
        sessionStorage.setItem(SESSION_KEY_LOGIN_INFO, data);
    }

    function get_loginInfo() {
        return sessionStorage.getItem(SESSION_KEY_LOGIN_INFO)
    }

    function set_theme(data) {
        localStorage.setItem(SESSION_KEY_THEME, data);
    }

    function get_theme() {
        return localStorage.getItem(SESSION_KEY_THEME);
    }

    return {
        'set_loginInfo': set_loginInfo,
        'get_loginInfo': get_loginInfo,
        'set_theme': set_theme,
        'get_theme': get_theme,
    };
})();

export default session;